import { render, staticRenderFns } from "./AcademicProgressModifyDiscussionDate.vue?vue&type=template&id=1d04f083&scoped=true"
import script from "./AcademicProgressModifyDiscussionDate.vue?vue&type=script&lang=js"
export * from "./AcademicProgressModifyDiscussionDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d04f083",
  null
  
)

export default component.exports